const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Outlines"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.329,51.872a1,1,0,0,1-.128,1.476A29,29,0,0,1,7.466,48.256,1,1,0,0,1,7.713,46.8l3.4-2.192a1,1,0,0,1,1.312.21,22.965,22.965,0,0,0,30.86,3.957A1,1,0,0,1,44.6,48.9Z",
    style: {
      fill: "#40ccf1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,30a28.878,28.878,0,0,1-7.24,19.172,1,1,0,0,1-1.48,0L47.553,46.2a1,1,0,0,1-.013-1.328A22.954,22.954,0,0,0,53,30a22.425,22.425,0,0,0-.84-6.11v-.01l4.632-1.719a1,1,0,0,1,1.318.676A28.988,28.988,0,0,1,59,30Z",
    style: {
      fill: "#3fdab1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.384,18.312l-3.779,1.413a1,1,0,0,1-1.235-.489,23.034,23.034,0,0,0-17.48-12.2A1,1,0,0,1,32,6.048V2.01a1,1,0,0,1,1.092-1A28.943,28.943,0,0,1,55.94,16.935,1,1,0,0,1,55.384,18.312Z",
    style: {
      fill: "#fccb55"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,2.012V6.049a1,1,0,0,1-.889.99A23.105,23.105,0,0,0,9.276,39.949a1.007,1.007,0,0,1-.346,1.288l-3.389,2.2a1,1,0,0,1-1.435-.373,29.151,29.151,0,0,1,22.8-42.063A1,1,0,0,1,28,2.012Z",
    style: {
      fill: "#a696f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 14,
    style: {
      fill: "#346d92"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Lines"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,36a1,1,0,0,1-.707-1.707l10-10a1,1,0,0,1,1.414,1.414l-10,10A1,1,0,0,1,25,36Z",
    style: {
      fill: "#f0f2f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,28a3,3,0,1,1,3-3A3,3,0,0,1,25,28Zm0-4a1,1,0,1,0,1,1A1,1,0,0,0,25,24Z",
    style: {
      fill: "#f0f2f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,38a3,3,0,1,1,3-3A3,3,0,0,1,35,38Zm0-4a1,1,0,1,0,1,1A1,1,0,0,0,35,34Z",
    style: {
      fill: "#f0f2f5"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadial);
export default __webpack_public_path__ + "static/media/radial.b10796dfa61225c45591edff74c0991f.svg";
export { ForwardRef as ReactComponent };